import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { CurrencyLabel } from 'Shared/CurrencyLabel'

const Item = ({
  description,
  subtitle,
  value,
  currency,
  cssColor,
  icon,
  parentOrderId,
  vendorName
}) => {
  let vendor = vendorName ? (
    <Fragment>
      {' '}
      <br />
      {vendorName}
    </Fragment>
  ) : (
    ''
  )
  return (
    <div className='extract-item pos-relative row'>
      <div className='col-2 col-sm-1 pl-0 my-2 zindex-low'>
        <i
          className={`icon icon_${icon} txt-body-lg`}
          style={icon === 'cash' ? { position: 'relative', left: '5px' } : {}}
        />
      </div>
      <div className='col mt-3'>
        <p className='txt-subtitle'>{subtitle}</p>
        <p className='mt-half txt-body-sm'>
          <strong>
            {parentOrderId ? `#${parentOrderId} - ` : ''}
            {description}
            {vendor}
          </strong>
        </p>
        <p className='d-block d-md-none mt-1'>
          <CurrencyLabel
            value={value}
            {...currency}
            className={`txt-body-sm ${cssColor}`}
          />
        </p>
      </div>
      <div className='d-none d-md-block col-auto mt-3'>
        <p>
          <CurrencyLabel
            value={value}
            {...currency}
            className={`txt-body-sm ${cssColor}`}
          />
        </p>
      </div>
    </div>
  )
}

Item.propTypes = {
  description: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  cssColor: PropTypes.string.isRequired,
  currency: PropTypes.object.isRequired,
  icon: PropTypes.string.isRequired,
  parentOrderId: PropTypes.number,
  vendorName: PropTypes.string
}

export default Item



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/Item.js